import { Shield, Zap, Clock, Users, CheckCircle2, Headphones, Award, TrendingUp, Star, Smartphone, Laptop } from "lucide-react";

const features = [
  {
    title: "Certifications Apple", subtitle: "Expertise reconnue et certifiée",
    description: "Nos agents certifiés ont démontré leur expertise et leur compétence en passant avec succès les rigoureux programmes de formation d'Apple.",
    ui: (
      <div className="bg-white rounded-lg shadow-lg p-4 border border-gray-200">
        <div className="flex items-center justify-between mb-4">
          <h4 className="font-semibold text-gray-900">Certifications</h4>
          <div className="px-2 py-1 bg-green-100 text-green-700 rounded-full text-xs font-medium">Actif</div>
        </div>
        <div className="space-y-3">
          {[{ n: "Apple Certified Support Professional", d: "2024" }, { n: "Apple Service Fundamentals", d: "2024" }, { n: "macOS Support Essentials", d: "2023" }].map((c, i) => (
            <div key={i} className="flex items-center gap-3 p-2 rounded-lg bg-gray-50">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center"><Award className="w-5 h-5 text-white" /></div>
              <div className="flex-1"><div className="text-sm font-medium text-gray-900">{c.n}</div><div className="text-xs text-gray-500">Validé en {c.d}</div></div>
              <CheckCircle2 className="w-5 h-5 text-green-500" />
            </div>
          ))}
        </div>
      </div>
    ),
  },
  {
    title: "À la Pointe de la Technologie", subtitle: "Formation continue et innovation",
    description: "Avec des formations continues, nos techniciens restent à l'avant-garde des technologies et des solutions Apple.",
    ui: (
      <div className="bg-white rounded-lg shadow-lg p-4 border border-gray-200">
        <div className="flex items-center justify-between mb-4"><h4 className="font-semibold text-gray-900">Technologies</h4><TrendingUp className="w-5 h-5 text-blue-600" /></div>
        <div className="space-y-3">
          {[{ t: "macOS Sonoma", p: 95 }, { t: "iOS 17", p: 88 }, { t: "iPadOS 17", p: 92 }].map((it, i) => (
            <div key={i} className="space-y-2">
              <div className="flex justify-between text-sm"><span className="font-medium text-gray-900">{it.t}</span><span className="text-gray-600">{it.p}%</span></div>
              <div className="w-full bg-gray-200 rounded-full h-2"><div className="bg-gradient-to-r from-blue-500 to-blue-600 h-2 rounded-full" style={{ width: `${it.p}%` }}></div></div>
            </div>
          ))}
        </div>
      </div>
    ),
  },
  {
    title: "Confiance et Fiabilité", subtitle: "Service de la plus haute qualité",
    description: "La certification Apple Professional Support n'est pas seulement un badge. C'est la preuve que nous nous engageons à vous fournir un service de la plus haute qualité.",
    ui: (
      <div className="bg-white rounded-lg shadow-lg p-4 border border-gray-200">
        <div className="flex items-center justify-between mb-4"><h4 className="font-semibold text-gray-900">Satisfaction</h4><div className="flex items-center gap-1"><Star className="w-4 h-4 text-yellow-500 fill-yellow-500" /><span className="text-sm font-semibold text-gray-900">4.9/5</span></div></div>
        <div className="space-y-3">
          {[{ m: "Taux de résolution", v: "98%", c: "text-green-600" }, { m: "Temps moyen", v: "1h 30min", c: "text-blue-600" }, { m: "Clients satisfaits", v: "99%", c: "text-purple-600" }].map((it, i) => (
            <div key={i} className="flex items-center justify-between p-3 rounded-lg bg-gray-50"><span className="text-sm text-gray-700">{it.m}</span><span className={`text-sm font-bold ${it.c}`}>{it.v}</span></div>
          ))}
        </div>
      </div>
    ),
  },
  {
    title: "Rapidité et Efficacité", subtitle: "Résolution rapide des problèmes",
    description: "Grâce à leur formation approfondie, nos agents résolvent les problèmes rapidement et efficacement, réduisant le temps d'inactivité.",
    ui: (
      <div className="bg-white rounded-lg shadow-lg p-4 border border-gray-200">
        <div className="flex items-center justify-between mb-4"><h4 className="font-semibold text-gray-900">Temps de réponse</h4><Clock className="w-5 h-5 text-blue-600" /></div>
        <div className="space-y-4">
          <div className="text-center p-4 rounded-lg bg-blue-50"><div className="text-3xl font-bold text-blue-600 mb-1">1h 30min</div><div className="text-xs text-gray-600">Temps moyen</div></div>
          <div className="grid grid-cols-3 gap-2">
            {[{ l: "Urgent", t: "30min", c: "text-red-600" }, { l: "Normal", t: "2h", c: "text-blue-600" }, { l: "Faible", t: "4h", c: "text-gray-600" }].map((it, i) => (
              <div key={i} className="text-center p-2 rounded bg-gray-50"><div className={`text-xs font-semibold mb-1 ${it.c}`}>{it.t}</div><div className="text-xs text-gray-500">{it.l}</div></div>
            ))}
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "Prêt pour l'Avenir", subtitle: "Investissement continu dans l'excellence",
    description: "Chaque agent en formation est une promesse que nous continuons à investir dans l'excellence pour votre satisfaction.",
    ui: (
      <div className="bg-white rounded-lg shadow-lg p-4 border border-gray-200">
        <div className="flex items-center justify-between mb-4"><h4 className="font-semibold text-gray-900">Équipe</h4><Users className="w-5 h-5 text-blue-600" /></div>
        <div className="space-y-3">
          {[{ r: "Experts certifiés", c: 45, I: Award }, { r: "En formation", c: 12, I: TrendingUp }, { r: "Disponibles 24/7", c: 30, I: Clock }].map((it, i) => (
            <div key={i} className="flex items-center gap-3 p-2 rounded-lg bg-gray-50">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center"><it.I className="w-5 h-5 text-white" /></div>
              <div className="flex-1"><div className="text-sm font-medium text-gray-900">{it.r}</div><div className="text-xs text-gray-500">{it.c} agents</div></div>
            </div>
          ))}
        </div>
      </div>
    ),
  },
  {
    title: "Pour tous les appareils Apple", subtitle: "Support complet de l'écosystème",
    description: "Que ce soit pour des réparations, des conseils d'optimisation ou des formations, nous sommes là pour vous aider.",
    ui: (
      <div className="bg-white rounded-lg shadow-lg p-4 border border-gray-200">
        <div className="flex items-center justify-between mb-4"><h4 className="font-semibold text-gray-900">Appareils supportés</h4><div className="flex gap-1"><Smartphone className="w-4 h-4 text-gray-600" /><Laptop className="w-4 h-4 text-gray-600" /></div></div>
        <div className="grid grid-cols-2 gap-2">
          {[{ n: "MacBook", c: 120, I: Laptop }, { n: "iMac", c: 45, I: Laptop }, { n: "iPhone", c: 200, I: Smartphone }, { n: "iPad", c: 80, I: Smartphone }].map((d, i) => (
            <div key={i} className="p-3 rounded-lg bg-gray-50 text-center"><d.I className="w-6 h-6 mx-auto mb-2 text-blue-600" /><div className="text-xs font-semibold text-gray-900">{d.n}</div><div className="text-xs text-gray-500">{d.c} unités</div></div>
          ))}
        </div>
      </div>
    ),
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-20 lg:py-32 bg-gradient-to-br from-background via-purple-50/20 to-background relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_50%,rgba(168,85,247,0.03),transparent_50%)] pointer-events-none"></div>
      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl lg:text-5xl font-bold text-foreground mb-6">Pourquoi choisir Mac-Support Pro Solution ?</h2>
          <p className="text-lg lg:text-xl text-muted-foreground leading-relaxed">Une expertise certifiée et reconnue pour garantir la continuité de votre activité</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
          {features.map((f, i) => (
            <div key={i} className="space-y-4 flex flex-col">
              <div className="space-y-1">
                <h3 className="text-xl lg:text-2xl font-bold text-foreground">{f.title}</h3>
                <p className="text-sm font-medium text-primary">{f.subtitle}</p>
              </div>
              <div className="transform hover:scale-[1.02] transition-transform duration-300 flex-shrink-0">{f.ui}</div>
              <p className="text-muted-foreground leading-relaxed text-base flex-grow">{f.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
